/* ------------------------------------------------------------------ */
/*  Faith 1st — brand tokens (Architectural redesign, 2026-02-26)      */
/*                                                                     */
/*  The site is no longer ivory-led. The atmosphere is now defined by  */
/*  Smoked Ink + Deep Mineral Blue. Dry Stone is the working light     */
/*  neutral; Soft Parchment is rare and used only for moments of       */
/*  disclosure (e.g. the inquiry form).                                */
/* ------------------------------------------------------------------ */
export const C = {
  // ── DARK SURFACES — define the emotional world ───────────────────
  bgDark: "#16181B",          // Smoked Ink — primary grounding (replaces black)
  surfacePrimary: "#123F57",  // Deep Mineral Blue — moodier dark-field surface

  // ── LIGHT SURFACES — used selectively ────────────────────────────
  surfaceLight: "#FFFFFF",    // White — primary working surface (was Dry Stone tan)
  surfaceLight2: "#EEE8DD",   // Soft Parchment — rare reveal only

  // ── ACCENTS ──────────────────────────────────────────────────────
  accentMetal: "#A88A57",     // Restrained Brass — numbered systems, linework
  accentFunctional: "#2F6B73", // Oxidized Teal — interaction / CTA color
  supportOrganic: "#5F6553",  // Slate Olive — image framing, layered depth

  // ── STRUCTURAL NEUTRALS ──────────────────────────────────────────
  borderSoft: "#8F8B83",      // Paper Shadow — mid-tone borders
  dividerLight: "#B7B4AE",    // Mist Gray — softened lines on dark fields

  // ── TEXT ─────────────────────────────────────────────────────────
  textOnDark: "#F4F1EA",      // Witness White — warmer than stark white
  textOnLight: "#1C1E20",     // Near-ink on light surfaces

  // ── ALPHA UTILITIES ──────────────────────────────────────────────
  brassSoft: "rgba(168,138,87,0.30)",   // brass @ 30% — structural rails
  brassLine: "rgba(168,138,87,0.55)",   // brass @ 55% — accent linework
  brassMute: "rgba(168,138,87,0.18)",   // brass @ 18% — very quiet rail
  inkOver: "rgba(22,24,27,0.40)",       // smoked ink overlay on imagery
  paperOver: "rgba(143,139,131,0.30)",  // paper shadow div on light
  mistOver: "rgba(183,180,174,0.18)",   // mist gray on dark surfaces
  inkOnLight: "rgba(28,30,32,0.70)",    // body text on dry stone
  inkOnLightSoft: "rgba(28,30,32,0.55)",
  whiteOnDark: "rgba(244,241,234,0.78)",
  whiteOnDarkSoft: "rgba(244,241,234,0.55)",
};

/* Corner-radius system — soften content modules, keep sections sharp */
export const R = {
  card: 14,      // large service cards / founder module (12–16px)
  resource: 12,  // resource cards, small content boxes
  button: 7,     // buttons (6–8px)
  field: 7,      // form inputs (6–8px)
  pill: 999,     // small metadata tags
  section: 0,    // full section containers stay sharp
};

export const TAGLINE = "People. Culture. Leadership.";
export const TAGLINE_LONG = "Faith in people, excellence in culture.";

/* ------------------------------------------------------------------ */
/*  Practice marker — small evidentiary stat used in hero / footer    */
/*  to ground the brand without becoming a marketing claim.            */
/* ------------------------------------------------------------------ */
export const PRACTICE_MARK = {
  yearsLabel: "TWO DECADES",
  yearsBody:
    "of practice at the intersection of employment law, senior HR judgment, and executive coaching.",
};
